import ManageRatingsPage from './ManageRatingsPage';

export default ManageRatingsPage;
export { default as reducer } from './ratings.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageRatingsPage/index.tsx